module.exports = __webpack_public_path__ + "static/img/logo_a.903e1e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_a.png
// module id = uWQc
// module chunks = 0